// extracted by mini-css-extract-plugin
module.exports =  {"card-footer":"l6b9kPf","cardFooter":"l6b9kPf"};